import Router from 'next/router'
import { useEffect, useRef } from 'react'
import LoadingBar from 'react-top-loading-bar'

interface RefType {
  staticStart: () => void
  continuousStart: () => void
  complete: () => void
}

const ProgressBar: React.FC = () => {
  const ref = useRef<RefType>(null)

  useEffect(() => {
    if (ref.current) {
      const handleRouteChangeStart = () => ref.current?.continuousStart()
      const handleRouteChangeComplete = () => ref.current?.complete()
      const handleRouteChangeError = () => ref.current?.complete()

      Router.events.on('routeChangeStart', handleRouteChangeStart)
      Router.events.on('routeChangeComplete', handleRouteChangeComplete)
      Router.events.on('routeChangeError', handleRouteChangeError)

      return () => {
        Router.events.off('routeChangeStart', handleRouteChangeStart)
        Router.events.off('routeChangeComplete', handleRouteChangeComplete)
        Router.events.off('routeChangeError', handleRouteChangeError)
      }
    }
  }, [])

  return (
    <LoadingBar
      ref={ref}
      color="#00D1B6"
      height={5}
      shadow={false}
      style={{
        borderTopRightRadius: '5px',
        borderBottomRightRadius: '5px',
      }}
    />
  )
}

export default ProgressBar
